import { render, staticRenderFns } from "./ProductVehicleContextBar.vue?vue&type=template&id=66572c86"
import script from "./ProductVehicleContextBar.vue?vue&type=script&lang=js"
export * from "./ProductVehicleContextBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports